<template lang="pug">
  .home
    vue-headful(
      :title="title"
    )
    slim-grid(:data="gridData" :columnOptions="columnOptions" pk="field__name" :height="1200")

</template>

<script>
import modelApi from '@/services/ModelApi'
import SlimGrid from 'vue-slimgrid'

export default {
  name: 'ModelGrid',
  components: { SlimGrid },
  data: function () {
    return {
      title: '',
      gridData: [],
      columnOptions: {
        // Options applied to all columns.
        '*': {
          order (column) {
            return parseInt(column.id, 10)
          },
          formatter (row, cell, value) {
            value = value.toLocaleString()
            return `
              <span class="disabled">
                ${value}
                </span>
              `
          }
        },
        // Options only applied to 'col1'.
        Field: {
          name: 'Field',
          order: -10,
          hidden: false,
          sortable: true,
          resizable: true,
          focusable: true,
          selectable: true,
          headerInput: false,
          headerFilter: false,
          formatter (row, cell, value) {
            return `
                <span class="disabled">
                  ${value}
                </span>
              `
          }
        }
      }
    }
  },
  mounted () {
    this.updateData(this.$route.query)
  },
  computed: {},
  methods: {
    updateData (params) {
      modelApi.fetchGridModel(params, this.$route.params.id).then(response => {
        this.gridData = response.data.data
      })
    }
  }
}
</script>

<style src="vue-slimgrid/dist/slimgrid.css"></style>
